import React from 'react';
import { CellProps } from 'react-table';
import { AccessAccountsTableRow } from 'common/types/types';

const AccessAccountsIdCell = ({ value }: CellProps<AccessAccountsTableRow, string>) => {
  return <div className='text-base font-medium capitalize'>{value}</div>;
};

export { AccessAccountsIdCell };
